import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Text from '@ingka/text';
import SSRIcon from '@ingka/ssr-icon';
import { EmptyStateProps } from './EmptyStateProps';

const EmptyState: FC<EmptyStateProps> = ({ message, icon }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={2}
    sx={{ margin: 'auto', maxWidth: 574, textAlign: 'center' }}
  >
    {icon && <SSRIcon paths={icon} />}
    <Text textStyle="Body.L">{message}</Text>
  </Stack>
);

export default EmptyState;
